import React from "react";

export const Sec = ({ id, active, children }) => (
  <section className={`chapter${active === id ? " active" : ""}`} id={id}>
    {children}
  </section>
);

export const Sop = ({ id, title, chips, purpose, cr, children }) => (
  <div className="sop">
    <div className="plate"><span>{id}</span></div>
    <div className="bd">
      <h3>{title}</h3>
      <div className="chips">
        {chips.map((c, i) => (
          <span key={i} className={i === 0 ? "chip own" : "chip"}>{c}</span>
        ))}
      </div>
      {purpose && <div className="purpose">{purpose}</div>}
      <ol>{children}</ol>
      <div className="cr">{cr}</div>
    </div>
  </div>
);

export const Pol = ({ title, children }) => (
  <div className="pol">
    <div className="pt">{title}</div>
    {children}
  </div>
);

export const Rule = ({ children }) => <div className="rule">{children}</div>;

export const V = ({ children }) => <span className="verify">{children}</span>;
